/**
 * @generated SignedSource<<5a1c083c8d393f86c47674234778c6f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConversationHistory_Query$variables = {
  contactId?: string | null | undefined;
  days?: number | null | undefined;
  limit?: number | null | undefined;
  sessionId?: string | null | undefined;
  userId?: string | null | undefined;
};
export type ConversationHistory_Query$data = {
  readonly conversationHistory: {
    readonly data: {
      readonly messages: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly message: string | null | undefined;
        readonly sessionId: string | null | undefined;
        readonly source: string | null | undefined;
        readonly timestamp: string | null | undefined;
      } | null | undefined>;
      readonly summary: string | null | undefined;
      readonly totalMessages: number | null | undefined;
    };
  } | null | undefined;
};
export type ConversationHistory_Query = {
  response: ConversationHistory_Query$data;
  variables: ConversationHistory_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "days"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contactId",
        "variableName": "contactId"
      },
      {
        "kind": "Variable",
        "name": "days",
        "variableName": "days"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "ConversationHistory",
    "kind": "LinkedField",
    "name": "conversationHistory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConversationHistoryData",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ConversationMessage",
            "kind": "LinkedField",
            "name": "messages",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timestamp",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "summary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMessages",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationHistory_Query",
    "selections": (v5/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ConversationHistory_Query",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "763abe8449bc8a296d8296847d845ed0",
    "id": null,
    "metadata": {},
    "name": "ConversationHistory_Query",
    "operationKind": "query",
    "text": "query ConversationHistory_Query(\n  $userId: String\n  $contactId: String\n  $sessionId: String\n  $limit: Int\n  $days: Int\n) {\n  conversationHistory(userId: $userId, contactId: $contactId, sessionId: $sessionId, limit: $limit, days: $days) {\n    data {\n      messages {\n        id\n        message\n        source\n        timestamp\n        sessionId\n      }\n      summary\n      totalMessages\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "488739f127b8e82a3920c69a17f43ed5";

export default node;
